import { apiPost } from '@/lib/apiFetch';
import type { ActivitySummary, ActivityWindow } from '@/lib/activity';

/**
 * Fetch the user-activity rollup.
 *
 * Through /api/activity rather than the Supabase client, because
 * public.user_sessions has no RLS policies and its grants are revoked - a
 * browser session cannot read it at all. The route is what checks the caller
 * is a super_admin, so the restriction holds whether or not the route guard in
 * App.tsx is reached.
 */
export async function fetchActivitySummary(days: ActivityWindow): Promise<ActivitySummary> {
  return apiPost<ActivitySummary>('/api/activity', { action: 'summary', days });
}
